import { useCallback, useEffect, useState } from 'react';

export default function useSpeechRecognition(language: string) {
  const [isListening, setIsListening] = useState<boolean>(false);
  const [recognition, setRecognition] = useState<any>(null);
  const [transcript, setTranscript] = useState<string>('');

  useEffect(() => {
    // Check if API is available by browser
    let SpeechRecognition =
      (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;

    if (SpeechRecognition) {
      const recognition = new SpeechRecognition();
      recognition.continuous = true;
      recognition.interimResults = true;
      recognition.lang = language;

      recognition.onresult = (event: any) => {
        let currentTranscript = '';
        for (let i = event.resultIndex; i < event.results.length; i++) {
          const result = event.results[i];
          if (result.isFinal) {
            currentTranscript += result[0].transcript;
          }
        }

        setTranscript((prev) => prev + currentTranscript);
      };

      recognition.onend = () => {
        setIsListening(false);
      };

      setRecognition(recognition);
    }
    return () => {
      if (recognition) {
        recognition.stop();
      }
    };
  }, []);

  // Start speech recognition
  const startListening = useCallback(() => {
    if (recognition && !isListening) {
      recognition.start();
      setIsListening(true);
    }
  }, [isListening, recognition]);

  // Stop speech recognition
  const stopListening = useCallback(() => {
    if (recognition && isListening) {
      recognition.stop();
      setIsListening(false);
    }
  }, [isListening, recognition]);

  // Clear speech recognition
  const clearTranscript = useCallback(() => {
    setTranscript('');
  }, [isListening, recognition]);

  const updatedTranscription = (value: string) => {
    setTranscript(value);
  };

  return {
    transcript,
    isListening,
    startListening,
    stopListening,
    clearTranscript,
    updatedTranscription,
  };
}
